import strings from '../../../../../../../common/Translation/Translate';
import { VenueConfigLayoutItem } from './MappingLayoutCards';

export const getRowLayoutId = (row: any): number | null => {
  const id = row?.layouts?.value ?? row?.layoutId;
  return id != null ? Number(id) : null;
};

export const validateCapacity = (min: any, max: any): string => {
  const minStr = String(min ?? '').trim();
  const maxStr = String(max ?? '').trim();
  if (!minStr || !maxStr) {
    return strings.requiredText;
  }
  const minN = parseInt(minStr, 10);
  const maxN = parseInt(maxStr, 10);
  if (Number.isNaN(minN) || Number.isNaN(maxN) || minN < 1 || maxN < 1) {
    return strings.requiredText;
  }
  if (minN >= maxN) {
    return strings.venueConfig_mapping_maxCapacity_error;
  }
  return '';
};

export const isCapacityComplete = (min: any, max: any): boolean => {
  const minStr = String(min ?? '').trim();
  const maxStr = String(max ?? '').trim();
  return Boolean(minStr && maxStr);
};

export const buildConfiguredByLayoutId = (editedData: any[]): Map<number, any> => {
  const map = new Map<number, any>();
  editedData.forEach(row => {
    const layoutId = getRowLayoutId(row);
    if (layoutId != null) {
      map.set(layoutId, row);
    }
  });
  return map;
};

export const mergeLayoutItemsWithConfigured = (
  layoutItems: VenueConfigLayoutItem[],
  editedData: any[],
): VenueConfigLayoutItem[] => {
  const seen = new Set(layoutItems.map(item => Number(item.id)));
  const merged = [...layoutItems];
  editedData.forEach(row => {
    const layoutId = getRowLayoutId(row);
    if (layoutId != null && !seen.has(layoutId)) {
      merged.push({
        id: layoutId,
        name: row.layouts?.label || row.layoutName || String(layoutId),
      });
      seen.add(layoutId);
    }
  });
  return merged.sort((a, b) => a.name.localeCompare(b.name));
};
